import * as ENDPOINTS from '@/common/constants/endpoints'

import { api } from '../api'

export const getPix = async () => {
  const response = await api<Pix>(ENDPOINTS.PIX_KEY, { method: 'POST' })

  if (!response) return undefined

  return response
}
